import { render, staticRenderFns } from "./itemEdit.vue?vue&type=template&id=efa1b566&scoped=true"
import script from "./itemEdit.vue?vue&type=script&lang=js"
export * from "./itemEdit.vue?vue&type=script&lang=js"
import style0 from "./itemEdit.vue?vue&type=style&index=0&id=efa1b566&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa1b566",
  null
  
)

export default component.exports